import React from "react";
import {
  RemovalConfirmationContainer,
  ButtonsContainer,
} from "./RemovalConfirmation.styles";
import { useTheme } from "@mui/material/styles";
import { Button } from "..";
import { Icon } from "../../icons";
import { Box } from "@mui/material";

export interface CustomRemovalConfirmationProps {
  primaryButtonText: string;
  cancelButtonText: string;
  onPrimaryButtonClick: Function;
  loading?: boolean;
  disabled?: boolean;
}

export const RemovalConfirmation = ({
  primaryButtonText,
  cancelButtonText,
  onPrimaryButtonClick,
  loading,
  disabled,
  ...rest
}: CustomRemovalConfirmationProps) => {
  const theme = useTheme();

  const [firstClick, setFirstClick] = React.useState<boolean>(false);

  return (
    <RemovalConfirmationContainer>
      {!firstClick ? (
        <Box
          onClick={() => {
            if (!disabled) { 
              setFirstClick(true);
            }
          }}
          sx={(theme) => ({ 
            color: theme.colors["neutral.400"],
            cursor: disabled ? "not-allowed" : "pointer", 
            pointerEvents: "auto",
            opacity: disabled ? 0.7 : 1
          })}
        >
          <Icon
            icon="Trash"
          />
        </Box>
      ) : (
        <ButtonsContainer>
          <Button
            variant="destructive"
            size="sm"
            onClick={(any) => onPrimaryButtonClick(any)}
            loading={loading}
            disabled={disabled}
          >
            {primaryButtonText}
          </Button>
          <Button
            variant="secondaryDark"
            size="sm"
            onClick={() => {
              setFirstClick(false);
            }}
            disabled={disabled}
          >
            {cancelButtonText}
          </Button>
        </ButtonsContainer>
      )}
    </RemovalConfirmationContainer>
  );
};

export interface RemovalConfirmationProps
  extends React.ComponentProps<typeof RemovalConfirmation> {
  as?: React.ElementType;
}

RemovalConfirmation.displayName = "RemovalConfirmation";
